import { MEMBERSHIP_MODELS } from "../models";

const CONTENT_TYPES = MEMBERSHIP_MODELS.contentTypes;
export const prefixDictionary = {
  [CONTENT_TYPES.article.codename.toString()]: "articles",
  [CONTENT_TYPES.event_page.codename.toString()]: "attend",
  [CONTENT_TYPES.coach.codename.toString()]: "coaches",
  [CONTENT_TYPES.reward.codename.toString()]: "rewards-and-benefits",
};